import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/vipbeijingtu.png'


const _withScopeId = n => (_pushScopeId("data-v-bfcbe39c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = { class: "tabs1" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "常见问题", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont" }, "", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("template", null, null, -1))
const _hoisted_8 = { class: "viprecord" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "常见问题解答", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "record" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "boxs" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "number" }, "01"),
    /*#__PURE__*/_createElementVNode("div", { class: "blue" }, "Q: 个人会员未到期可以办理企业会员吗?"),
    /*#__PURE__*/_createElementVNode("div", { class: "xian" }),
    /*#__PURE__*/_createElementVNode("div", { class: "black" }, [
      /*#__PURE__*/_createElementVNode("p", null, "A："),
      /*#__PURE__*/_createTextVNode(" 可以，如个人会员未到期办理企业会员，按个人会员剩余金额抵扣后办理企业会员，计算公式（企业会员实付金额-个人会员剩余天数×个人会员价格/天） ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "boxs" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "number" }, "02"),
    /*#__PURE__*/_createElementVNode("div", { class: "blue" }, "Q：企业会员可以办理个人会员吗？"),
    /*#__PURE__*/_createElementVNode("div", { class: "xian" }),
    /*#__PURE__*/_createElementVNode("div", { class: "black" }, [
      /*#__PURE__*/_createElementVNode("p", null, "A："),
      /*#__PURE__*/_createTextVNode(" 可在企业账户余额小于50齿轮币时办理个人会员，办理后会员身份标识将展 示个人会员，企业会员所有权益全部失效。 ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "boxs" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "number" }, "03"),
    /*#__PURE__*/_createElementVNode("div", { class: "blue" }, "Q：办理个人会员需要个人认证吗？"),
    /*#__PURE__*/_createElementVNode("div", { class: "xian" }),
    /*#__PURE__*/_createElementVNode("div", { class: "black" }, [
      /*#__PURE__*/_createElementVNode("p", null, "A："),
      /*#__PURE__*/_createTextVNode(" 办理个人会员无需个人认证 ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "boxs" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "number" }, "04"),
    /*#__PURE__*/_createElementVNode("div", { class: "blue" }, "Q：办理企业会员需要认证吗"),
    /*#__PURE__*/_createElementVNode("div", { class: "xian" }),
    /*#__PURE__*/_createElementVNode("div", { class: "black" }, [
      /*#__PURE__*/_createElementVNode("p", null, "A："),
      /*#__PURE__*/_createTextVNode(" 办理企业会员需要先进行企业认证 ")
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FirmVipTop = _resolveComponent("FirmVipTop")!
  const _component_PersonageTOP = _resolveComponent("PersonageTOP")!
  const _component_personage_vip = _resolveComponent("personage-vip")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_firm_vip = _resolveComponent("firm-vip")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_Title = _resolveComponent("Title")!
  const _component_InvoiceDialog = _resolveComponent("InvoiceDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.vipinfo.type == 2)
      ? (_openBlock(), _createBlock(_component_FirmVipTop, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.vipinfo.type == 1)
      ? (_openBlock(), _createBlock(_component_PersonageTOP, { key: 1 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "wenti",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setDialogVisible()))
        }, _hoisted_6),
        _createVNode(_component_el_tabs, {
          modelValue: _ctx.activeName,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.activeName) = $event)),
          class: "demo-tabs",
          onTabClick: _ctx.handleClick
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: "个人会员",
              name: "first"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_personage_vip)
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, {
              label: "企业会员",
              name: "second"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_firm_vip)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "onTabClick"])
      ])
    ]),
    _createVNode(_component_InvoiceDialog, {
      ref: "sonRef",
      dialogwidth: "580px"
    }, {
      header: _withCtx(() => [
        _createVNode(_component_Title, {
          headerHeight: 40,
          headerBC: "#F2F5FA"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        })
      ]),
      default: _withCtx(({}) => [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("i", {
              class: "iconfont",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.mclose()))
            }, "")
          ]),
          _hoisted_11
        ])
      ]),
      _: 1
    }, 512)
  ], 64))
}